export function isNeositek() {
  return window.location.hostname.match(/(neositek)/) !== null;
}
